import * as React from "react";

export const Dash = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none">
      <path stroke="#737373" strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.167 10h11.666" />
    </svg>
  );
};
